export var GasolineMovieType;
(function (GasolineMovieType) {
    GasolineMovieType["Basic"] = "basic";
    GasolineMovieType["Story"] = "brilliant-story";
})(GasolineMovieType || (GasolineMovieType = {}));
export var GasolineMovieBackgroundType;
(function (GasolineMovieBackgroundType) {
    GasolineMovieBackgroundType["LightGray"] = " light-gray";
})(GasolineMovieBackgroundType || (GasolineMovieBackgroundType = {}));
export const GASOLINE_MOVIE_MAP = {
    [GasolineMovieType.Basic]: {
        label: 'Basic',
    },
    [GasolineMovieType.Story]: {
        label: 'Brilliant Story',
    },
};
